import { useState } from "react";
import { HelpCircle, ChevronDown } from "lucide-react";

// Plain-language, jargon-free explainers for someone who's never used a trading terminal.
const INFO = {
  board: {
    title: "What is the Deal Board?",
    body: "This is the live list of open offers. Each row is a person wanting to buy or sell a large block of tokens at a set price, privately, without moving the market. Click any row to inspect it and, if you like the price, fund your side of the trade.",
  },
  mine: {
    title: "What are My Escrows?",
    body: "These are the deals you're part of — offers you posted and any trades you've funded. Track their progress here, and if a counterparty never shows up, this is where you get your deposit back.",
  },
  simulator: {
    title: "What is the Impact Simulator?",
    body: "A what-if calculator. Type in a token and how much you'd sell, and it shows how far the price would drop if you dumped it into the open market — and how much a private Cross trade would save you instead.",
  },
  tape: {
    title: "What is Trade History?",
    body: "A public feed of every completed trade. It shows the size, price and how much price damage each deal avoided. Nothing here can be faked — it's the running proof that the system works.",
  },
  trust: {
    title: "What is Token Trust?",
    body: "Quick safety signals for each token: how few wallets hold most of the supply, how new it is, and whether its liquidity is locked. Glance here before agreeing to trade a token you don't know well.",
  },
  docs: {
    title: "What is this page?",
    body: "A plain-English walkthrough of how a Cross trade works from start to finish — and, at the bottom, why your funds stay safe the entire time.",
  },
};

export const SectionInfo = ({ view }) => {
  const [open, setOpen] = useState(false);
  const info = INFO[view];
  if (!info) return null;
  return (
    <div className="shrink-0 rounded border border-line bg-s1/70 overflow-hidden" data-testid={`section-info-${view}`}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={`section-info-toggle-${view}`}
        aria-expanded={open}
        className="w-full flex items-center gap-2 px-3 h-9 text-left text-fog hover:text-white transition-colors"
      >
        <HelpCircle size={14} className="text-violet-300 shrink-0" />
        <span className="text-xs font-medium">{open ? info.title : "New here? What is this section?"}</span>
        <ChevronDown size={14} className={`ml-auto shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 pt-0 text-sm text-slate-400 leading-relaxed border-t border-line/60" data-testid={`section-info-body-${view}`}>
          <p className="pt-2 max-w-3xl">{info.body}</p>
        </div>
      )}
    </div>
  );
};
